import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notification_success: {
    isNotification: false,
    type: '',
    action: '',
    message: '',
  },
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    notificationSuccess(state, action) {
      state.notification_success = action.payload;
    },
  },
});

export const { notificationSuccess } = notificationSlice.actions;
export default notificationSlice.reducer;
